import {Spinner} from '@time-webkit/all/atoms/spinner';
import classNames from 'classnames';

import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';

import {useIntl} from 'react-intl';

import styles from './styles.module.css';

interface Props {
    show: boolean;
}

export const Loader: React.FC<Props> = (props) => {
    const {formatMessage} = useIntl();
    const typographyStyle = useTypography({size: TypographySize.BodyM});

    if (!props.show) {
        return null;
    }

    return (
        <div className={classNames(styles.container, typographyStyle)}>
            <Spinner size={16} />
            <span>{formatMessage({id: 'form_upload_image.loading', defaultMessage: 'Loading photo'})}</span>
        </div>
    );
};
